
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { Constants, Utils } from '../../helpers';
import { SignalRTypes, SportEventsActionTypes } from '../actions';

const getOverTimeTopBetTypesPayload = (data) => {
	if (!data || typeof data !== 'object') {
		return undefined;
	}

	if (data.overTimeTopBetTypes !== undefined) {
		return data.overTimeTopBetTypes;
	}

	const nestedCandidates = [data.data, data.Data, data.payload, data.Payload];
	for (const nested of nestedCandidates) {
		if (nested && nested !== data) {
			const found = getOverTimeTopBetTypesPayload(nested);
			if (found !== undefined) {
				return found;
			}
		}
	}

	return undefined;
}

const getNormalizedBetTypes = (payload) => {
	if (!payload) {
		return { optionsBetTypes: [], match: null };
	}

	if (payload.topBetTypes && Array.isArray(payload.topBetTypes)) {
		return payload.topBetTypes.length > 0
			? Utils.handleBetTypes(payload.topBetTypes)
			: { optionsBetTypes: [], match: null };
	}

	if (payload.overTimeTopBetTypes && Array.isArray(payload.overTimeTopBetTypes)) {
		return payload.overTimeTopBetTypes.length > 0
			? Utils.handleBetTypes(payload.overTimeTopBetTypes)
			: { optionsBetTypes: [], match: null };
	}

	if (Array.isArray(payload)) {
		return payload.length > 0
			? Utils.handleBetTypes(payload)
			: { optionsBetTypes: [], match: null };
	}

	if (payload.optionsBetTypes || payload.match !== undefined) {
		return {
			optionsBetTypes: payload.optionsBetTypes || [],
			match: payload.match || null,
		};
	}

	return { optionsBetTypes: [], match: null };
}


export function* requests() {

	yield takeEvery(SignalRTypes.SportEvents_Response, function* ({ response }) {
		try {
			window.console.response("Events", response)
			const { app } = yield select();

			switch (response.status) {
				case 1:
					let betTypes = Utils.handleBetTypes(response.data.topBetTypes);

					const overTimeTopBetTypesPayload = getOverTimeTopBetTypesPayload(response.data);
					let overTimeBetTypes = getNormalizedBetTypes(overTimeTopBetTypesPayload);

					const sortedSportEvents = sortEventsByDate(response.data.sportEvents);
					const sortedUpcomingEvents = sortEventsByDate(response.data.upcomingEvents);

					let selectedValues = [];

					if (
						betTypes &&
						Array.isArray(betTypes.optionsBetTypes) &&
						betTypes.optionsBetTypes.length > 0
					) {
						for (let i = 0; i < Constants.ColumnsNumber; i++) {
							selectedValues[i] =
								betTypes.optionsBetTypes[i] && betTypes.optionsBetTypes[i].key;
						}
					}

					yield put({
						type: SportEventsActionTypes.SportEvents_Success,
						betTypes: betTypes,
						overTimeBetTypes: overTimeBetTypes,
						sportEvents: sortedSportEvents,
						eventOdds: response.data.eventOdds,
						eventsIds: Object.keys(sortedSportEvents),
						upcomingEvents: sortedUpcomingEvents,
						upcomingEventIds: Object.keys(sortedUpcomingEvents),
						selectedValues: selectedValues,
						outrightEvents: response.data.outrightEvents,
						outrightEventCount: response.data.outrightEventCount,
						sportEventCount: response.data.sportEventCount,
						teamStandings: response.data.teamStandings,
					});

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					});

					break;
				case 3:

					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;

				default:
					break;
			}

			let item = null;
			let eventId = app.match.params["eventId"];
			let newEventId = `${app.feedId}_${app.match.params.sport}_${eventId}`

			//Refresh page
			if (eventId) {
				item = response.data.sportEvents[newEventId]
			}

			//If no item, dont try load all bet types
			if (!item)
				return;

			//else Set the event item and get all Bettypes of sport event
			//yield put({ type: SportEventsActionTypes.Set_Event, item: item });
			//yield put({ type: SignalRTypes.AllBetTypes_Request })


		} catch (e) {
			window.log("ERROR", e)
		}
	})

	yield takeEvery(SignalRTypes.KironSportEvents_Response, function* ({ response }) {
		try {
			window.console.response("Kiron Events", response)
			const { app, sportEvents } = yield select();

			switch (response.status) {
				case 1:

					let data = [];
					Object.values(response.data).map((item) =>
						data.push(

							{
								...item,
								eventDate: item.eventDateOfMatchFormated,
								eventNumber: item.kironEventNumber
							})



					)
					yield put({
						type: SportEventsActionTypes.SportEvents_Events_FeedChange,
						sportEvents: response.data,

					})

					let event = Object.values(response.data)[0];
					yield put(push(`/casino/${event.feed.feedId}/${event.sport.sportId}/${event.kironEventNumber}/${event.eventId}`));

					break;



				case 3:

					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;
				default:

			}

		} catch (e) {
			window.log("ERROR", e)
		}
	})

	yield takeEvery(SignalRTypes.AllBetTypes_Response, function* ({ response }) {
		try {
			let events = {};
			yield put({ type: SportEventsActionTypes.Set_Event, item: response.data.sportEvent, drawEvents: response.data && response.data.drawEvents });
			if (response.data.sportEvent) {
				events[response.data.sportEvent.key] = response.data.sportEvent
			}
			window.console.response("All BetTypes", response)

			let drillDownTabs = [];
			response.data.eventOddGroups && Object.values(response.data.eventOddGroups).map(item => drillDownTabs.pushUnique(item.betTypeDrillDownGroupName))
			switch (response.status) {
				case 1:
					let specialGroupOdds = {};
					let newFilteredGroupIds = [];
					let specialOddFields = [];
					let specialOddFieldGroup = {}
					const eventSpecialTemplateOddGroupIds = response.data.eventSpecialTemplateOddGroupIds;
					eventSpecialTemplateOddGroupIds && response.data.eventOdds && eventSpecialTemplateOddGroupIds.map(group => {
						group.goalScorer.map((groupKey) => {
							Object.entries(response.data.eventOdds).map(([key, odds]) => {
								Object.keys(odds).map((key) => {
									if (
										`${odds[key].betType.betTypeGroupId}_${odds[key].betType.betTypeGroupName}` ===
										groupKey
									) {
										specialGroupOdds[key] = odds[key];
									}
								});
							});
						})
					})
					const eventOddGroupIds = response.data.eventOddGroupIds;
					if (eventSpecialTemplateOddGroupIds && Object.values(eventSpecialTemplateOddGroupIds) && Object.values(eventSpecialTemplateOddGroupIds).length > 0) {
						(eventOddGroupIds.map(groupId => {
							Object.values(eventSpecialTemplateOddGroupIds).map((specialGroupId) => {
								Object.values(specialGroupId).map(values => {
									if (!(values.includes(groupId) && (values.indexOf(groupId) !== values.length - 1))) {
										newFilteredGroupIds.push(groupId)
									}
								})
							})

						}))
					} else {
						newFilteredGroupIds = eventOddGroupIds
					}
					eventSpecialTemplateOddGroupIds && eventSpecialTemplateOddGroupIds.map(specialIdGroup => {
						Object.values(specialIdGroup).map(group => {
							group.map((groupId, idx) => {
								response.data.eventOddFields && Object.values(response.data.eventOddFields).map(item => {
									Object.values(item).map(oddField => {
										if ((`${oddField.betType.betTypeGroupId}_${oddField.betType.betTypeGroupName}` == groupId) && oddField.betType.specialTemplateName && oddField.oddFieldColumn == idx + 1) {
											specialOddFields.push(oddField)
										}
									})
								})
							})
						})
					})
					specialOddFields && specialOddFields.length > 0 && specialOddFields.map((oddField) => {
						if (specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`]) {
							specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`].push(oddField)
						} else {
							specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`] = [oddField]
						}
					})
					yield put({
						type: SportEventsActionTypes.SportEvents_Success,
						betTypes: {},
						sportEvents: events,
						eventOddGroups: response.data.eventOddGroups,
						eventOddGroupIds: newFilteredGroupIds,
						eventOdds: response.data.eventOdds,
						specialGroupOdds: specialGroupOdds,
						specialOddFieldGroup: specialOddFieldGroup,
						eventsIds: response.data.sportEvent ? [response.data.sportEvent.key] : [],
						selectedValues: [],
						upcomingEvents: {},
						upcomingEventIds: [],
						drillDownTabs: drillDownTabs
					})

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					})
					yield put({
						type: SignalRTypes.Get_Draw_Odds_Response,
					})

					break;

				case 3:
					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;

			}
		} catch (e) {
			window.log("ERROR", e)
		}
	})
	yield takeEvery(SignalRTypes.KironEvent_Response, function* ({ response }) {
		try {
			let oddFields = {};
			yield put({ type: SportEventsActionTypes.Set_Event, item: response.data.sportEvent });
			window.console.response("Kiron All BetTypes", response)
			switch (response.status) {
				case 1:

					yield put({
						type: SportEventsActionTypes.SportEvents_Odds_Success,
						eventOdds: response.data.eventOdds,
					})

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					})

					break;

				case 3:
					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;
				default:

			}
		} catch (e) {
			window.log("ERROR", e)
		}
	})
}

function sortEventsByDate(events) {
	if (!events || typeof events !== "object") return {};

	return Object.entries(events)
		.sort(([, a], [, b]) => {
			const aDate = new Date(a && a.eventDateOfMatch ? a.eventDateOfMatch : 0).getTime();
			const bDate = new Date(b && b.eventDateOfMatch ? b.eventDateOfMatch : 0).getTime();
			return aDate - bDate;
		})
		.reduce((acc, [key, value]) => {
			acc[key] = value;
			return acc;
		}, {});
}

export default function* sportSaga() {
	yield all([
		fork(requests),
	])
}
